import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles.ts'
import { FormModeProvider } from '../../base/contexts/FormModeContext.tsx'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext.tsx'
import { Loadable } from '../base/components/Lodable'
import { ArticuloRecetaInputProps } from './interfaces/articuloReceta.ts'
import {
  ArticuloRecetaFormMode,
  articuloRecetaFormModeConfig,
  articuloRecetaFormModeDefault,
} from './services/articuloRecetaFormMode.ts'

const ArticuloRecetaGestion = Loadable(lazy(() => import('./view/articuloRecetaGestion.tsx')))
const ArticuloRecetaRegistro = Loadable(lazy(() => import('./view/articuloRecetaRegistro.tsx')))
const ArticuloRecetaActualizar = Loadable(lazy(() => import('./view/articuloRecetaActualizar.tsx')))

export const articuloRecetaRoutesMap = {
  gestion: {
    path: '/articulo-receta',
    name: 'Receta de mostrador',
    action: 'ARTICULO_RECETA',
  },
  registro: {
    path: '/articulo-receta/registro',
    name: 'Nueva receta de mostrador',
    action: 'ADMINISTRAR_ARTICULO_RECETA',
  },
  actualizar: {
    path: '/articulo-receta/actualizar/:id',
    name: 'Actualizar receta',
    action: 'ADMINISTRAR_ARTICULO_RECETA',
  },
}

const articuloRecetaRoutes = [
  {
    path: articuloRecetaRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <ArticuloRecetaGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRecetaRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <ArticuloRecetaRegistro />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRecetaRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<ArticuloRecetaInputProps, ArticuloRecetaFormMode>
          mode="edit"
          config={articuloRecetaFormModeConfig}
          defaults={articuloRecetaFormModeDefault}
        >
          <ArticuloRecetaActualizar />
        </FormModeProvider>
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default articuloRecetaRoutes
